import {Box} from "@unibuddy/patron";
import * as React from "react";
import {useUniversityContext} from "../../providers/UniversityProvider";
import {getenv} from "../../utils/getenv";

const LOGO = "unibuddy-logo.png";

export const UnibuddyImpressionsLogo = () => {
    const {universityId} = useUniversityContext();
    const LOGO_URL = getenv("LOGO_URL");
    const UB_SERVICE = getenv("UB_SERVICE");
    const url = `${LOGO_URL}/logos/${UB_SERVICE}/${universityId}/${LOGO}`;

    if (!universityId || !LOGO_URL || !UB_SERVICE) return null;

    return (
        <Box style={{display: "none", visibility: "hidden"}}>
            <img src={url} id="__decorative-logo" alt="Decorative Logo" />
        </Box>
    );
};
